/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsuranceRuleConfig
 */
export interface InsuranceRuleConfig {
    /**
     * 
     */
    rule_type: InsuranceRuleConfigRuleTypeEnum;
    /**
     * 
     */
    insurance_type: InsuranceRuleConfigInsuranceTypeEnum;
    /**
     * Title rendered with the row's threshold, or the catalog default.
     */
    rule_title: string;
    /**
     * Title with the `{N}` placeholder left in, for live previews.
     */
    title_template: string;
    /**
     * 
     */
    threshold_default: number | null;
    /**
     * 
     */
    threshold_min: number | null;
    /**
     * 
     */
    threshold_max: number | null;
    /**
     * 
     */
    enabled: boolean;
    /**
     * The insurance_rules row; null when the rule is disabled.
     */
    id: string | null;
    /**
     * 
     */
    qualifier: InsuranceRuleConfigQualifierEnum | null;
    /**
     * 
     */
    threshold: number | null;
    /**
     * Read-only display rank; null when the rule is disabled.
     */
    rule_rank: number | null;
}


/**
 * @export
 */
export const InsuranceRuleConfigRuleTypeEnum = {
    MedicareActiveCoverage: 'medicare_active_coverage',
    MedicareNoMaOrMsp: 'medicare_no_ma_or_msp',
    MedicareSnfDaysRemaining: 'medicare_snf_days_remaining',
    MedicareNoRecentSnfStay: 'medicare_no_recent_snf_stay',
    MedicareQualifyingStay: 'medicare_qualifying_stay',
    MedicareSnfAdmissionWindow: 'medicare_snf_admission_window',
    ManagedMedicareInNetwork: 'managed_medicare_in_network',
    ManagedMedicareActiveCoverage: 'managed_medicare_active_coverage',
    ManagedMedicareSnfCoverage: 'managed_medicare_snf_coverage',
    ManagedMedicareCoverageRunway: 'managed_medicare_coverage_runway',
} as const;
export type InsuranceRuleConfigRuleTypeEnum = typeof InsuranceRuleConfigRuleTypeEnum[keyof typeof InsuranceRuleConfigRuleTypeEnum];

/**
 * @export
 */
export const InsuranceRuleConfigInsuranceTypeEnum = {
    Medicare: 'Medicare',
    ManagedMedicare: 'Managed Medicare',
} as const;
export type InsuranceRuleConfigInsuranceTypeEnum = typeof InsuranceRuleConfigInsuranceTypeEnum[keyof typeof InsuranceRuleConfigInsuranceTypeEnum];

/**
 * @export
 */
export const InsuranceRuleConfigQualifierEnum = {
    DealBreaker: 'Deal Breaker',
    Warning: 'Warning',
} as const;
export type InsuranceRuleConfigQualifierEnum = typeof InsuranceRuleConfigQualifierEnum[keyof typeof InsuranceRuleConfigQualifierEnum];


/**
 * Check if a given object implements the InsuranceRuleConfig interface.
 */
export function instanceOfInsuranceRuleConfig(value: object): value is InsuranceRuleConfig {
    if (!('rule_type' in value) || value['rule_type'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('rule_title' in value) || value['rule_title'] === undefined) return false;
    if (!('title_template' in value) || value['title_template'] === undefined) return false;
    if (!('threshold_default' in value) || value['threshold_default'] === undefined) return false;
    if (!('threshold_min' in value) || value['threshold_min'] === undefined) return false;
    if (!('threshold_max' in value) || value['threshold_max'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    if (!('rule_rank' in value) || value['rule_rank'] === undefined) return false;
    return true;
}

export function InsuranceRuleConfigFromJSON(json: any): InsuranceRuleConfig {
    return InsuranceRuleConfigFromJSONTyped(json, false);
}

export function InsuranceRuleConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuranceRuleConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'rule_type': json['rule_type'],
        'insurance_type': json['insurance_type'],
        'rule_title': json['rule_title'],
        'title_template': json['title_template'],
        'threshold_default': json['threshold_default'],
        'threshold_min': json['threshold_min'],
        'threshold_max': json['threshold_max'],
        'enabled': json['enabled'],
        'id': json['id'],
        'qualifier': json['qualifier'],
        'threshold': json['threshold'],
        'rule_rank': json['rule_rank'],
    };
}

export function InsuranceRuleConfigToJSON(json: any): InsuranceRuleConfig {
    return InsuranceRuleConfigToJSONTyped(json, false);
}

export function InsuranceRuleConfigToJSONTyped(value?: InsuranceRuleConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rule_type': value['rule_type'],
        'insurance_type': value['insurance_type'],
        'rule_title': value['rule_title'],
        'title_template': value['title_template'],
        'threshold_default': value['threshold_default'],
        'threshold_min': value['threshold_min'],
        'threshold_max': value['threshold_max'],
        'enabled': value['enabled'],
        'id': value['id'],
        'qualifier': value['qualifier'],
        'threshold': value['threshold'],
        'rule_rank': value['rule_rank'],
    };
}

